import { Injectable, Injector } from '@angular/core';
import { GlobalsService } from '../services/globals.service';
import { ListenerBase } from './listener-base';
import * as $ from 'jquery';
import { Documento } from '../models/documento.model';
import { DocumentoDaoService } from '../dao/documento-dao-service';
import { MenuItem } from '../app.component';

export type DadosSei = {
  processo: {
    id_processo: number,
    tipo_processo_codigo: string,
    tipo_processo_nome: string,
    numero_processo: string,
    assuntos: { [key: string]: string },
    interessados: { [key: string]: string },
    numero: string,
    descricao: string,
    observacoes: string,
    nivel_acesso: string,
    hipotese_legal: string
  } | undefined,
  documento?: {
    id_documento: number,
    numero_documento: number,
    titulo_documento: string,
    tipo_documento_codigo: string
    tipo_documento_nome: string
    assunto_documento: string,
    prazo_documento: string,
    assinatura_documento: string,
    versao_documento: string,
    data_documento: string
  } | undefined,
  link_montar_arvore?: string
} | undefined;

export type SeiKeys = { 
  id_processo: number, 
  numero_processo: string, 
  id_documento?: number, 
  numero_documento?: string 
};

export type TipoProcessoSei = {
  codigo: string, 
  nome: string
};

export type TipoDocumentoSei = {
  codigo: string, 
  nome: string
};

export type InclusaoDocumentoSei = { 
  id_processo: number, 
  id_documento: number, 
  numero_processo: string, 
  numero_documento: number,
  titulo_documento: string,
  tipo_documento_nome: string,
  urlEditor: string, 
  idUser: string, 
  urlReload: string 
};

@Injectable({
  providedIn: 'root'
})
export class ListenerAllPagesService extends ListenerBase {

  public signedUrl?: string;
  public documentoDaoService: DocumentoDaoService;

  constructor(public injector: Injector) {
    super(injector, "all_pages");
    //@ts-ignore
    this.signedUrl = typeof MD_MULTIAGENCIA_PETRVS_AJAX != "undefined" ? MD_MULTIAGENCIA_PETRVS_AJAX : undefined;
    this.documentoDaoService = injector.get<DocumentoDaoService>(DocumentoDaoService);
    this.ngOnInit();
  }

  public getButtonTitle(processo?: string, documento?: number): string {
    return documento ? 'Sei nº ' + documento : (processo?.length ? "Processo " + processo : 'Sem processo vinculado');
  }

  public getDadosDocumento(numeroDocumento: string): Promise<DadosSei | undefined> {
    if(this.gb.isSeiModule) {
      return this.ajax("dados_documento", {numero: numeroDocumento});
    } else {
      return this.execute<DadosSei | undefined>("getDadosDocumento", [numeroDocumento]);
    }
  }

  public async getProcessoKeys(): Promise<SeiKeys | undefined>  {
    return await this.execute<SeiKeys>("getProcessoKeys", []) as SeiKeys;
  }

  public async getDocumentoKeys(): Promise<SeiKeys | undefined>  {
    return await this.execute<SeiKeys>("getDocumentKeys", []) as SeiKeys;
  }

  public async getSeiKeys(): Promise<SeiKeys | undefined>  {
    return await this.execute<SeiKeys>("getSeiKeys", []) as SeiKeys;
  }

  public getDadosProcesso(numeroProcesso: string): Promise<DadosSei | undefined> {
    if(this.gb.isSeiModule) {
      return this.ajax("dados_processo", {numero: numeroProcesso});
    } else {
      return this.execute<DadosSei | undefined>("getDadosProcesso", [numeroProcesso]);
    }
  }

  public openDocumentoSei(id_processo: number, id_documento?: number) {
    window?.open((this.auth.entidade?.url_sei || this.gb.URL_SEI) + "sei/controlador.php?acao=procedimento_trabalhar&id_procedimento=" + id_processo + (id_documento ? "&id_documento=" + id_documento : ""), '_blank')?.focus();
  }

  public getTiposProcessos(): Promise<TipoProcessoSei[]> {
    if(this.gb.isSeiModule) {
      return this.ajax("listar_tipos_procedimento", {});
    } else {
      return this.execute<TipoProcessoSei[]>("getTiposProcessos", []);
    }
  }

  public getTiposDocumentos(): Promise<TipoDocumentoSei[]> {
    if(this.gb.isSeiModule) {
      return this.ajax("listar_tipos_documento", {});
    } else {
      return this.execute<TipoDocumentoSei[]>("getTiposDocumentos", []);
    }
  }

  public async addDocumento(documento: Documento, processo: DadosSei): Promise<Documento | undefined> {
    try {
      if(this.gb.isSeiModule) {
        let dadosDocumento = await this.ajax("adicionar_documento_interno", {
          id_processo: processo?.processo?.id_processo,
          codigo_tipo_documento: documento.tipo_documento?.codigo,
          conteudo_base64: btoa(documento.conteudo || "")
        }) as DadosSei;
        if(dadosDocumento?.documento?.numero_documento) {
          documento.link = {
            tipo: "SEI",
            id_processo: dadosDocumento.processo?.id_processo,
            numero_processo: dadosDocumento.processo?.numero_processo,
            id_documento: dadosDocumento.documento?.id_documento,
            numero_documento: dadosDocumento.documento?.numero_documento,
            tipo_processo_codigo: dadosDocumento.processo?.tipo_processo_codigo,
            tipo_processo_nome: dadosDocumento.processo?.tipo_processo_nome,
            tipo_documento_codigo: dadosDocumento.documento?.tipo_documento_codigo,
            tipo_documento_nome: dadosDocumento.documento?.tipo_documento_nome,
            titulo_documento: dadosDocumento.documento?.titulo_documento
          };
          await this.documentoDaoService.save(documento);
          await this.execute<void>("recarregarArvore", [dadosDocumento.link_montar_arvore]);
        }
      } else {
        if(!documento.tipo_documento?.codigo?.length) throw new Error("É obrigatório que o tipo de documento possua o código de integração Sei.");
        const documentoSei = await this.execute<InclusaoDocumentoSei | null>("incluirDocumento", [processo?.processo?.id_processo, documento.tipo_documento?.codigo]);
        if (documentoSei) {
          documento.link = {
            tipo: "SEI",
            id_processo: processo?.processo?.id_processo,
            numero_processo: processo?.processo?.numero_processo,
            id_documento: documentoSei.id_documento,
            numero_documento: documentoSei.numero_documento,
            tipo_processo_codigo: processo?.processo?.tipo_processo_codigo,
            tipo_processo_nome: processo?.processo?.tipo_processo_nome,
            tipo_documento_codigo: documento.tipo_documento?.codigo!,
            tipo_documento_nome: documentoSei.tipo_documento_nome,
            titulo_documento: documentoSei.titulo_documento
          };
          documento.status = "AGUARDANDO_SEI";
          await this.documentoDaoService.save(documento);
          await this.execute<void>("recarregarArvore", [documentoSei.urlReload]);
          await this.execute<InclusaoDocumentoSei | null>("abrirEditor", [documentoSei.urlEditor, documentoSei.idUser]);
        }
      }
    } catch (error: any) {
      this.dialog.alert("Erro ao adicionar documento", error.message ? error.message : error);
    } 
    return documento;
  }

  public ajax(action: string, params?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if(this.signedUrl?.length) {
        const url = this.signedUrl;
        this.signedUrl = undefined;
        $.ajax({
          type: "POST",
          url: url,
          cache: false,
          data: {
            action: action,
            params: JSON.stringify(params)
          },
          converters: { 'text xml': (result) => result },
          dataType: "xml",
        }).done((xml: string) => {
          try {
            let xmlDoc = $.parseXML(xml);
            let $xmlDom = $(xmlDoc);
            this.signedUrl = atob($xmlDom.find("next").text());
            if($xmlDom.find("error")?.text()?.length) {
              let error = atob($xmlDom.find("error").text()); 
              reject(error);
            } else if($xmlDom.find("erro")?.attr("descricao")?.length) {
              reject($xmlDom.find("erro")?.attr("descricao"));
            } else {
              let data = JSON.parse(atob($xmlDom.find("data").text()));
              resolve(data);
            }
          } catch (error: any) {
            reject({ error: error.toString() });
          }          
        }).fail((error) => {
          reject({ error: error });
        });
      } else {
        reject({ error: "O Petrvs não consegue se comunicar com o SEI. Favor recarregar a página e tentar novamente." });
      }
    });
  }

}
